import styled from 'styled-components';

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: space-between;
    margin-top: 50px;
  }
`;